"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastItem = exports.resolveFontStyle = exports.translateFont = exports.getFonts = void 0;
function getFonts(document) {
    try {
        const elements = document.querySelectorAll('g[font-family]');
        const fonts = {};
        elements.forEach((element) => {
            var _a, _b;
            const fontFamily = element.getAttribute('font-family');
            const fontStyle = (_a = element.getAttribute('font-style')) !== null && _a !== void 0 ? _a : 'normal';
            const fontWeight = (_b = element.getAttribute('font-weight')) !== null && _b !== void 0 ? _b : 'Regular';
            const fontId = element.getAttribute('custom-font-id');
            const fontKey = `${fontId !== null && fontId !== void 0 ? fontId : fontFamily} ${fontStyle} ${fontWeight}`;
            fonts[fontKey] = {
                fontFamily: fontFamily,
                fontStyle,
                fontWeight,
                fontId,
            };
        });
        return fonts;
    }
    catch (error) {
        console.error('Error', error);
        return {};
    }
}
exports.getFonts = getFonts;
const FontWeightMap = {
    '100': 'Light',
    '400': 'Regular',
    '700': 'Bold',
    '900': 'Black',
};
const FontStyleMap = {
    normal: '',
    italic: 'Italic',
};
function translateFont(font) {
    const fontWeight = Number.isInteger(Number(font.fontWeight))
        ? FontWeightMap[font.fontWeight]
        : font.fontWeight;
    const fontStyle = resolveFontStyle(font);
    return `${font.fontFamily}-${fontWeight}${fontStyle}.ttf`;
}
exports.translateFont = translateFont;
function resolveFontStyle(font) {
    var _a;
    return (_a = FontStyleMap[font.fontStyle]) !== null && _a !== void 0 ? _a : '';
}
exports.resolveFontStyle = resolveFontStyle;
function getLastItem(thePath) {
    if (thePath) {
        return thePath.substring(thePath.lastIndexOf('/') + 1);
    }
    return undefined;
}
exports.getLastItem = getLastItem;
//# sourceMappingURL=font-utils.js.map